import { render, staticRenderFns } from "./QuestionStatusIcon.vue?vue&type=template&id=182172ec&scoped=true&"
import script from "./QuestionStatusIcon.vue?vue&type=script&lang=js&"
export * from "./QuestionStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./QuestionStatusIcon.vue?vue&type=style&index=0&id=182172ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182172ec",
  null
  
)

export default component.exports